import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import {
  Button,
  CssBaseline,
  TextField,
  Paper,
  Grid,
  Typography,
  Link
} from '@material-ui/core';

import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

import validate from '../../../utils/validate';
import { useHistory } from "react-router-dom";

import Copyright from '../Copyright';

import '../styles.scss';
import LogoSmall from '../../../assets/images/logo-small.png'
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import DescriptionIcon from '@material-ui/icons/Description';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Popover from '@material-ui/core/Popover';
import Logo from '../../../assets/images/logo_transparent.png'
import { getHeaders, setHeaders } from '../../../redux/utils';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  }
}));

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const Register = (props: any) => {
  const history = useHistory();
  const { loadingError } = props.auth;
  const { addToast } = props;

  const [registerData, setRegisterData] = useState({
    // firstName: '', 
    // lastName:'', 
    emailAddress: '',
    password: '',
    emailConfirmationCode: '',
    // organisation: '',
    // webAddress: ''
  } as any)

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const [errors, setErrors] = useState({} as any)
  const [emailFromParams, setEmailFromParams] = useState(false);
  useEffect(() => {
    const queryString = window.location.search;
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      const email = urlParams.get('email')
      const firstName = urlParams.get('first_name')
      const lastName = urlParams.get('last_name')
      // register?email=john@snow.com&first_name=John&last_name=Snow
      // clear parameters
      window.history.replaceState(null, '', window.location.pathname);
      if (email) {
        setEmailFromParams(true);
        setRegisterData({
          ...registerData,
          emailAddress: email,
          firstName: firstName,
          lastName: lastName,
        })
      }
    }
  }, [])

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setRegisterData({
      ...registerData,
      [name]: value
    });
  }

  const isEmptyObject = (obj: any) => Object.getOwnPropertyNames(obj).length == 0

  const handleRegister = (e: any) => {
    e.preventDefault()
    const validation = validate('register', registerData);
    setErrors({
      ...errors,
      // firstName: validation.firstName, 
      // lastName: validation.lastName, 
      emailAddress: validation.emailAddress,
      password: validation.password,
      // organisation: validation.organisation,
      // webAddress: validation.webAddress
    });

    const userData = {
      username: registerData.emailAddress.toLowerCase(),
      password: registerData.password,
      attributes: {
        email: registerData.emailAddress.toLowerCase(),
      }
    };

    if (isEmptyObject(validation)) {
      if (registerData.passwordConfirmation === registerData.password) {
        // props.signUp(userData);
        props.signUp(userData).then((r: any) => {
          if (r.code === 'UsernameExistsException') {
            addToast({ type: 'success', message: 'An account with the given email already exists, please log in.' })
            history.push('/login');
          } else {
            // history.push('/dashboard');
            // create issuer
            // const issuer = {
            //   organization_name: registerData.organisation,
            //   web_address: registerData.webAddress,
            //   issuer_first_name: registerData.firstName,
            //   issuer_last_name: registerData.lastName,
            //   issuer_email: registerData.emailAddress,
            //   logo_url: ''
            // }
            // props.registerIssuer(issuer)
            // .then((r: any) => {
            // })
            // .catch((e: any) => console.error(e))
          }
        })
      } else {
        addToast({ type: 'error', message: 'Passwords do not match' })
      }
    } else {
      // form is invalid
    }
  }

  const confirmRegister = (e: any) => {
    e.preventDefault()

    const userData = {
      Username: registerData.emailAddress.toLowerCase(),
      ConfirmationCode: registerData.emailConfirmationCode
    };

    props.confirmSignUp(userData).then(() => {
      props.login({ username: registerData.emailAddress, password: registerData.password }).then((r: any) => {
        Auth.currentSession().then((r: any) => {
          localStorage.setItem('jwt', r.accessToken.jwtToken)
          localStorage.setItem('jwt', r.idToken.jwtToken)
          setHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${r.accessToken.jwtToken}`,
            'IdToken': r.idToken.jwtToken
          });
          props.storeSession(r).then(() => { });
        })
      })
    });
  }

  return (
    <Grid container component="main" className='root register'>
      <CssBaseline />
      <Grid item xs={12} sm={4} md={4} lg={4} className='image'>
        <a href="https://gutenbergcerts.com" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '30px 30px 0' }}>
          <img style={{ width: '100%' }} src={Logo} alt="gutenberg cert logo" className='CertLogo' />
        </a>
        <div className="cert-steps" style={{ display: 'none' }}>
          <Typography component="h1" variant="h5">
            Create your certificate <br /> in 3 Easy Steps
          </Typography>
          <div className='step'>
            <CloudUploadIcon className='icon red' />
            <Typography component="h2"><b>Step 1: </b> Create/Select Template</Typography>
          </div>
          <div className='step'>
            <MailOutlineIcon className='icon red' />
            <Typography component="h2"><b>Step 2: </b> Upload Recipients</Typography>
          </div>
          <div className='step'>
            <DescriptionIcon className='icon red' />
            <Typography component="h2"><b>Step 3: </b> Send Certificates</Typography>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sm={8} md={8} lg={8} component={Paper}
        elevation={6} square className='flex right-side'>
        <div className='paper'>
          <section className='topside'>
            <div className='title'>
              <img src={LogoSmall} alt="small logo" className='small-logo hidden' />
              <section>
                <Typography component="h1" variant="h5">
                  Create an Account
                </Typography>
                <Typography component="h2">Already a member?
                  <Link component={RouterLink} to="/login" className='red bold signup'>
                    Log in
                  </Link>
                </Typography>
              </section>
            </div>
            {!props.auth.showConfirmRegister ? (
              <form className='form' noValidate>
                {loadingError && (
                  <Alert className='banner' severity="error">{loadingError && loadingError.message}</Alert>
                )}
                {emailFromParams && (
                  <>
                    <Typography gutterBottom variant="h6" component="h6">
                      One last step
                    </Typography>
                    <Typography className="mb-20" gutterBottom variant="body1" component="h6">
                      Please select a password and enter your organization information below.
                    </Typography>
                  </>
                )}
                <Grid container spacing={2} className="mt-20">
                  <Grid item xs={12}>
                    <TextField
                      error={errors.emailAddress ? true : false}
                      value={registerData.emailAddress}
                      onChange={e => handleChange(e)}
                      id={errors.emailAddress ? "outlined-error-helper-text" : "emailAddress"}
                      label={errors.emailAddress ? "Error" : "Email Address"}
                      helperText={errors.emailAddress ? `${errors.emailAddress}` : ''}
                      variant="outlined"
                      required
                      disabled={emailFromParams}
                      fullWidth
                      name="emailAddress"
                      autoComplete='register-email'
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={12} className="name">
                    <Grid item xs={12} sm={6} className="firstName">
                      <TextField
                        error={errors.firstName ? true : false}
                        value={registerData.firstName}
                        onChange={e => handleChange(e)}
                        id={errors.firstName ? "outlined-error-helper-text" : "firstName"}
                        label={errors.firstName ? "Error" : "First Name"}
                        helperText={errors.firstName ? `${errors.firstName}` : ''}
                        autoComplete="firstName"
                        name="firstName"
                        variant="outlined"
                        required
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={errors.lastName ? true : false}
                        value={registerData.lastName}
                        onChange={e => handleChange(e)}
                        id={errors.lastName ? "outlined-error-helper-text" : "lastName"}
                        label={errors.lastName ? "Error" : "Last Name"}
                        helperText={errors.lastName ? `${errors.lastName}` : ''}
                        variant="outlined"
                        required
                        fullWidth
                        name="lastName"
                        autoComplete="lname"
                      />
                    </Grid>
                  </Grid> */}
                  <Grid item xs={12} className="passwordInput">
                    <InfoOutlinedIcon aria-owns={open ? 'mouse-over-popover' : undefined}
                      aria-haspopup="true"
                      onMouseEnter={handlePopoverOpen}
                      onMouseLeave={handlePopoverClose}
                      className="passwordInfo"
                    />
                    <Popover
                      id="mouse-over-popover"
                      className={classes.popover}
                      classes={{
                        paper: classes.paper,
                      }}
                      open={open}
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      onClose={handlePopoverClose}
                      disableRestoreFocus
                    >
                      <li>Password needs to be at least 8 characters</li>
                      <li>Password must have at least one lower and one upper case character</li>
                      <li>Password needs at least one symbol($, !, @, _, *,etc)</li>
                      <li>Password must include one number or more</li>
                    </Popover>
                    <TextField
                      error={errors.password ? true : false}
                      value={registerData.password}
                      onChange={e => handleChange(e)}
                      id={errors.password ? "outlined-error-helper-text" : "password"}
                      label={errors.password ? "Error" : "Password"}
                      helperText={errors.password ? `${errors.password}` : ''}
                      variant="outlined"
                      required
                      fullWidth
                      name="password"
                      type="password"
                      autoComplete="current-password"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      error={errors.passwordConfirmation ? true : false}
                      value={registerData.passwordConfirmation}
                      onChange={e => handleChange(e)}
                      id={errors.passwordConfirmation ? "outlined-error-helper-text" : "password-confirmation"}
                      label={errors.password ? "Error" : "Confirm Password"}
                      helperText={errors.passwordConfirmation ? `${errors.passwordConfirmation}` : ''}
                      variant="outlined"
                      required
                      fullWidth
                      name="passwordConfirmation"
                      type="password"
                      autoComplete="current-password-confirmation"
                    />
                  </Grid>
                  {/* <Grid item xs={12}>
                    <TextField
                      error={errors.organisation ? true : false}
                      value={registerData.organisation}
                      onChange={e => handleChange(e)}
                      id={errors.organisation ? "outlined-error-helper-text" : "organisation"}
                      label={errors.organisation ? "Error" : "Organisation"}
                      helperText={errors.organisation ? `${errors.organisation}` : ''}
                      variant="outlined"
                      required
                      fullWidth
                      name="organisation"
                      autoComplete="organisation"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      error={errors.webAddress ? true : false}
                      value={registerData.webAddress ? registerData.webAddress : 'http://'}
                      onChange={e => handleChange(e)}
                      id={errors.webAddress ? "outlined-error-helper-text" : "webAddress"}
                      label={errors.webAddress ? "Error" : "Web Address"}
                      helperText={errors.webAddress ? `${errors.webAddress}` : ''}
                      variant="outlined"
                      fullWidth
                      name="webAddress"
                      autoComplete="webAddress"
                    />
                  </Grid> */}
                  <Grid item xs={12}>
                    {/* <FormControlLabel
                      control={<Checkbox value="allowExtraEmails" color="primary" />}
                      label="I want to receive inspiration, marketing promotions and updates via email."
                    /> */}
                  </Grid>
                </Grid>
                <div className="register">
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={(e) => handleRegister(e)}
                    className='submit red-bck white'
                  >
                    Continue
                  </Button>
                </div>
              </form>
            ) : (
              <form className='form' noValidate>
                {loadingError && (
                  <Alert className='banner' severity="error">{loadingError && loadingError.message}</Alert>
                )}
                <Typography className="mt-20 mb-20" gutterBottom variant="body1" component="h6">
                  Please confirm your account by entering the confirmation code received at the email address below.
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      disabled
                      error={errors.email ? true : false}
                      value={registerData.emailAddress.toLowerCase()}
                      onChange={e => handleChange(e)}
                      id={errors.email ? "outlined-error-helper-text" : "email"}
                      label={errors.email ? "Error" : "Email Address"}
                      helperText={errors.email ? `${errors.email}` : ''}
                      variant="outlined"
                      required
                      fullWidth
                      name="email"
                      autoComplete="email"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      value={registerData.emailConfirmationCode}
                      onChange={e => handleChange(e)}
                      id={errors.email ? "outlined-error-helper-text" : "emailConfirmationCode"}
                      label={errors.email ? "Error" : "Email Confirmation Code"}
                      variant="outlined"
                      required
                      fullWidth
                      name="emailConfirmationCode"
                      autoComplete="emailConfirmationCode"
                    />
                  </Grid>
                  <Grid item xs={12} className="register">
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={(e) => confirmRegister(e)}
                      className='submit red-bck white'
                    >
                      Confirm
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </section>
          <Grid container justify="flex-end" className="copyright hidden">
            <Copyright />
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
}

export default Register;
